var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmenuExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.478012L8 4.47801L7.21117 5.26685L4 2.05585L0.788834 5.26685L0 4.47801L4 0.478012Z",
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenuExpandIcon);
export default __webpack_public_path__ + "static/media/submenu_expand_icon.44f38a2310fe90afc4af2a184a499376.svg";
export { ForwardRef as ReactComponent };